export const I18N_SET_LANG = 'I18N_SET_LANG';
export const I18N_LOAD_LANG = 'I18N_LOAD_LANG';
